module.exports = __webpack_public_path__ + "img/50.2422ec98.svg";